import axios from 'axios';
import { apiConfig } from '../config/api';

const API_BASE_URL = apiConfig.baseUrl;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const adminApi = {
  // Games
  getGames: (page = 1, limit = 20) => 
    apiClient.get(`/api/admin/games?page=${page}&limit=${limit}`),
  
  createGame: (gameData) => 
    apiClient.post('/api/admin/games', gameData),
  
  updateGame: (id, gameData) => 
    apiClient.put(`/api/admin/games/${id}`, gameData),
  
  deleteGame: (id) => 
    apiClient.delete(`/api/admin/games/${id}`),
  
  setGameScore: (id, scoreData) => 
    apiClient.put(`/api/admin/games/${id}/score`, scoreData),

  // Teams
  getTeams: () => 
    apiClient.get('/api/admin/teams'),
  
  createTeam: (teamData) => 
    apiClient.post('/api/admin/teams', teamData),
  
  updateTeam: (id, teamData) => 
    apiClient.put(`/api/admin/teams/${id}`, teamData),
  
  deleteTeam: (id) => 
    apiClient.delete(`/api/admin/teams/${id}`),

  // Users
  getUsers: (page = 1, limit = 20) => 
    apiClient.get(`/api/admin/users?page=${page}&limit=${limit}`),
  
  updateUserRole: (id, role) => 
    apiClient.put(`/api/admin/users/${id}/role`, { role }),
  
  deleteUser: (id) => 
    apiClient.delete(`/api/admin/users/${id}`),

  // API Management
  updateSchedule: () => 
    apiClient.post('/api/admin/api/update-schedule'),
  
  updateScores: () => 
    apiClient.post('/api/admin/api/update-scores'),
  
  getApiStatus: () => 
    apiClient.get('/api/admin/api/status'),
  
  getUpcomingGames: (limit = 10) => 
    apiClient.get(`/api/admin/api/upcoming?limit=${limit}`),
  
  getRecentResults: (limit = 10) => 
    apiClient.get(`/api/admin/api/recent?limit=${limit}`),
};

export default apiClient;
